import React from 'react';

const ClockWithHighlight = ({ startAngle, endAngle, color }) => { 
    // Función para convertir un ángulo en coordenadas para SVG
    const polarToCartesian = (cx, cy, r, angle) => {
      const rad = (Math.PI / 180) * angle;
      return {
        x: cx + r * Math.cos(rad),
        y: cy + r * Math.sin(rad),
      };
    };
  
    // Función para describir un arco en SVG
    const describeArc = (x, y, r, startAngle, endAngle) => {
      const start = polarToCartesian(x, y, r, endAngle);
      const end = polarToCartesian(x, y, r, startAngle);
      const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  
      return [
        "M", x, y,
        "L", start.x, start.y, 
        "A", r, r, 0, largeArcFlag, 0, end.x, end.y,
        "Z"
      ].join(" ");
    };
  
    // Path para la porción roja
    const arcPath = describeArc(50, 50, 45, startAngle, endAngle);
  
    return (
      <svg width="80%" height="80%" viewBox="0 0 100 100">
        {/* Círculo externo del reloj */}
        <circle cx="50" cy="50" r="45" stroke="#234798" strokeWidth="3" fill="white" />
  
        {/* Porción roja según los ángulos */}
        <path d={arcPath} fill={color} />
  
        {/* Marcas de las horas */}
        {[...Array(12)].map((_, i) => {
          const angle = (i * 30) - 90; // Cada hora representa 30 grados, comenzando desde la parte superior
          const x1 = 50 + 35 * Math.cos((Math.PI / 180) * angle);
          const y1 = 50 + 35 * Math.sin((Math.PI / 180) * angle);
          const x2 = 50 + 45 * Math.cos((Math.PI / 180) * angle);
          const y2 = 50 + 45 * Math.sin((Math.PI / 180) * angle);
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#234798" strokeWidth="2" />;
        })}
  
        {/* Manecillas del reloj */}
        {/* Manecilla de horas */}
        <line x1="50" y1="50" x2="50" y2="30" stroke="#000000" strokeWidth="3" />
        {/* Manecilla de minutos */}
        <line x1="50" y1="50" x2="50" y2="20" stroke="#000000" strokeWidth="2" />
        {/* Manecilla de segundos */}
        <line x1="50" y1="50" x2="50" y2="10" stroke={color} strokeWidth="1" />
      </svg>
    );
  };

export default ClockWithHighlight;
